import { IGetOrdersResponse, IPayOrderResponse } from "types/order";
import { assign } from "xstate";
import { TCheckoutContext } from "./types";
import { deleteAllCookies, setCookie, setLocalStorage } from "utils";
import {
  regexCustomerID,
  regexNumberAndHyphenOnly,
  regexNumberOnly,
  regexTaxNumber,
} from "utils/regex";

export const actions = {
  setCustomerId: assign({
    params: (ctx: any, e: { value: string }) => {
      if (e.value !== "" && !regexNumberOnly.test(e.value)) {
        return ctx.params;
      }
      if (e?.value?.length >= 15) {
        return ctx.params;
      }
      return {
        ...ctx.params,
        CustomerID: e.value || "",
      };
    },
  }),
  setTaxNumber: assign({
    params: (ctx: any, e: { value: string }) => {
      if (e.value !== "" && !regexNumberAndHyphenOnly.test(e.value)) {
        return ctx.params;
      }
      if (e?.value?.length >= 15) {
        return ctx.params;
      }
      return {
        ...ctx.params,
        TaxNumber: e.value || "",
      };
    },
  }),
  trimParams: assign({
    params: (ctx: TCheckoutContext) => {
      return {
        CustomerID: ctx.params.CustomerID.trim() || "",
        TaxNumber: ctx.params.TaxNumber.trim() || "",
      };
    },
  }),
  setInvalid: assign({
    invalid: (ctx: TCheckoutContext) => {
      return {
        ...ctx.invalid,
        CustomerID: !regexCustomerID.test(ctx.params.CustomerID)
          ? "warning_modal_invalid_customer_id_format"
          : "",
        TaxNumber: !regexTaxNumber.test(ctx.params.TaxNumber)
          ? "warning_modal_invalid_tax_number_format"
          : "",
      };
    },
  }),
  setWarnModal: assign({
    warnModal: (ctx: any, e: { warnMessage: string }) => {
      return e.warnMessage || "";
    },
  }),
  resetInvalidCustomerId: assign({
    invalid: (ctx: TCheckoutContext) => {
      return {
        ...ctx.invalid,
        CustomerID: "",
      };
    },
  }),
  resetInvalidTaxNumber: assign({
    invalid: (ctx: TCheckoutContext) => {
      return {
        ...ctx.invalid,
        TaxNumber: "",
      };
    },
  }),
  navigateToCheckout: (
    ctx: TCheckoutContext,
    e: { route: (url: string) => void }
  ) => {
    e.route(
      `/checkout?CustomerID=${ctx.params.CustomerID}&TaxNumber=${ctx.params.TaxNumber}`
    );
  },
  redirectToLandingPage: (
    ctx: TCheckoutContext,
    e: { route: (url: string) => void }
  ) => {
    e.route("/");
  },
  resetState: assign({
    orders: () => {
      return [];
    },
    checksum: () => {
      return "";
    },
    paymentInfo: () => {
      return null;
    },
    params: (ctx, e: { route: (url: string) => void }) => {
      if (e.route) {
        e.route("/");
      }
      deleteAllCookies();
      return {
        CustomerID: "",
        TaxNumber: "",
      };
    },
    invalid: () => {
      return {
        CustomerID: "",
        TaxNumber: "",
      };
    },
    warnModal: () => {
      return "";
    },
  }),
  resetWarnModal: assign({
    warnModal: () => {
      return "";
    },
  }),
  saveOrders: assign({
    orders: (ctx: any, e: { data: IGetOrdersResponse }) => {
      return e.data.items.map((item) => ({ ...item, selected: false }));
    },
    checksum: (ctx: any, e: { data: IGetOrdersResponse }) => {
      setLocalStorage(e.data.checksum, "Checksum");
      setCookie(e.data.checksum, "Checksum");
      return e.data.checksum;
    },
    max_invoices: (ctx: any, e: { data: IGetOrdersResponse }) => {
      return e.data.max_invoices;
    },
  }),
  selectInvoice: assign({
    orders: (
      ctx: TCheckoutContext,
      e: { type: string; invoice_number: string }
    ) => {
      let newOrders = [...ctx.orders];
      newOrders = newOrders.map((order) => ({
        ...order,
        selected:
          order.invoice_number === e.invoice_number &&
          order.remaining_amount > 0
            ? !order.selected
            : order.selected,
      }));
      return newOrders;
    },
  }),
  selectAllInvoices: assign({
    orders: (ctx: TCheckoutContext, e: { type: string; selected: boolean }) => {
      let newOrders = [...ctx.orders];
      newOrders = newOrders.map((order) => ({
        ...order,
        selected: e.selected && order.remaining_amount > 0 ? true : false,
      }));
      return newOrders;
    },
  }),
  savePaymentInfo: assign({
    paymentInfo: (ctx, e: IPayOrderResponse) => {
      setLocalStorage(e.data, "payment_url");
      setCookie(e.data, "payment_url");
      return e.data;
    },
  }),
  goLink: assign({
    paymentInfo: (ctx: TCheckoutContext) => {
      window.location.href = `${ctx.paymentInfo.data}`;
      return ctx.paymentInfo;
    },
  }),
};
